/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Home_Brand_Banner1Inputs */

const vi_sitesettings_home_brand_banner1 = /** @type {(inputs: Sitesettings_Home_Brand_Banner1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banner thương hiệu dự phòng (khi không có slide)`)
};

/**

* @param {Sitesettings_Home_Brand_Banner1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_home_brand_banner1 = /** @type {((inputs?: Sitesettings_Home_Brand_Banner1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Home_Brand_Banner1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_home_brand_banner1(inputs)
});
export { sitesettings_home_brand_banner1 as "siteSettings_home_brand_banner" }